import { render } from "./AgreeToUsePersonalInfo.vue?vue&type=template&id=20551b86&scoped=true&ts=true"
import script from "./AgreeToUsePersonalInfo.vue?vue&type=script&lang=ts"
export * from "./AgreeToUsePersonalInfo.vue?vue&type=script&lang=ts"

import "./AgreeToUsePersonalInfo.vue?vue&type=style&index=0&id=20551b86&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20551b86"]])

export default __exports__